type FieldWorkAction = {
  label: string;
  description: string;
  onClick: () => void;
};

export function FieldWorkScreen({ manager, canUseForms, onVisits, onRoutes,
  onMap, onCalendar, onForms }: {
  manager: boolean;
  canUseForms: boolean;
  onVisits: () => void;
  onRoutes: () => void;
  onMap: () => void;
  onCalendar: () => void;
  onForms: () => void;
}) {
  const actions: FieldWorkAction[] = manager ? [
    { label: 'Visits', description: 'See cases awaiting a visit and scheduled work.', onClick: onVisits },
    { label: 'Team routes', description: 'Review assigned stops and adjust their order.', onClick: onRoutes },
    { label: 'Map', description: 'See planned stops by team and location.', onClick: onMap },
    { label: 'Calendar', description: 'See trips, appointments and follow-ups by date.', onClick: onCalendar },
  ] : [
    { label: 'My route', description: 'See your team’s stops and start field work.', onClick: onRoutes },
    { label: 'Visits', description: 'See the cases and visits you can access.', onClick: onVisits },
    { label: 'Map', description: 'See your assigned team’s planned stops.', onClick: onMap },
    { label: 'Calendar', description: 'See your team’s schedule and follow-ups.', onClick: onCalendar },
  ];
  if (canUseForms) actions.push({
    label: 'Forms', description: 'Open field wellness records and drafts.', onClick: onForms,
  });

  return <section className="pt-4 desktop:pt-6 space-y-4">
    <div>
      <h1>{manager ? 'Field Work' : 'My Team'}</h1>
      <p className="mt-1 text-sm text-neutral-700">
        {manager
          ? 'Follow the work after it has been planned. Team setup and clustering are in Planning.'
          : 'Your assigned routes, visits and schedule are together here.'}
      </p>
    </div>
    <div className="grid gap-3 desktop:grid-cols-2">
      {actions.map((action) => <div className="card space-y-2" key={action.label}>
        <h2 className="text-xl">{action.label}</h2>
        <p className="text-sm text-neutral-700">{action.description}</p>
        <button type="button" className="btn btn-secondary" onClick={action.onClick}>
          Open {action.label.toLowerCase()}
        </button>
      </div>)}
    </div>
  </section>;
}
